import { getFormattedLongDate } from '@lmt/unicorn-shared/app/components/patients/common';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { groupBy } from 'lodash';
import React from 'react';
import { DocumentItem } from '../../cases/components/documents/DocumentItem';
import { EmptyBlock } from './EmptyBlock';
import { PatientPanelHeader } from './PatientPanelHeader';

import styles from './PatientDocumentsPanel.module.scss';
import { FileInfoDto } from '@lmt/shared-types';

export interface PatientDocumentsProps {
  documents: FileInfoDto[];
  patientId?: number;
}

const PatientDocumentsPanel: React.FC<PatientDocumentsProps> = React.memo(
  function PatientDocumentsPanel(props) {
    const { documents, patientId } = props;
    const i18n = useScopedTranslation('patients.overview.documents');

    const groupedDocuments = groupBy(
      documents.sort(
        (a, b) => b.uploadDateTime!.getTime() - a.uploadDateTime!.getTime(),
      ),
      (document) => getFormattedLongDate(document.uploadDateTime),
    );

    if (documents.length === 0) {
      return (
        <div className={styles.container}>
          <EmptyBlock
            patientId={patientId}
            title={i18n.t('title')}
            text={i18n.t('empty')}
          />
        </div>
      );
    }

    return (
      <div className={styles.container} data-test-id="document-list">
        <PatientPanelHeader
          title={i18n.t('title')}
          patientId={patientId}
          className={styles.header}
        />
        <div className={styles.documentsContainer}>
          <div className={styles.documents}>
            {Object.keys(groupedDocuments).map((createDate) => (
              <div key={createDate} className={styles.dateGroupContainer}>
                <div className={styles.dateTitle} data-test-id={'date'}>
                  {createDate}
                </div>
                <div className={styles.dateGroupItems}>
                  {groupedDocuments[createDate].map((document) => (
                    <div key={document.id} className={styles.documentItem}>
                      <DocumentItem document={document} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  },
);

export default PatientDocumentsPanel;
